export default __webpack_public_path__ + "dcd1690774537ef64bfddfd65e93fddf.svg";